//批量流转
import React from 'react'
import { connect } from 'react-redux'

class OverTimeApplyBatchDiv extends React.Component {
    state = {
        errorMessage: null,
        changedValues基本信息: {},
        initValues基本信息: {}
    }

    handlerSave = () => {
        const { onSave, onClose, ids, action } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'OverTimeApplyBatchFlow',
            data: {
                ids,
                title: action,
                changedValues基本信息
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('执行成功')
                onSave && onSave()
                onClose && onClose()
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const { action } = this.props
        switch (action) {
            case '退回申请':
                return values.退回原因
        }
        return true
    }

    fieldset基本信息 = () => {
        const { action } = this.props
        switch (action) {
            case '提交':
                return [
                    { _text: '审核意见', maxRows: 3 },
                ]
            case '退回申请':
                return [
                    { _text: '退回原因', required: true, maxRows: 3 },
                ]
        }
    }
    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        return <Body data={this} maxWidth="800"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !canSave },
                    { _button: '取消', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}
export default connect()(OverTimeApplyBatchDiv)